document.addEventListener('DOMContentLoaded', () => {
  const dialog = document.querySelector('#modal')
  const closeButton = document.querySelector('#closeButton')
  const prevButton = document.querySelector('#prevButton')
  const nextButton = document.querySelector('#nextButton')

  if (!dialog || !closeButton || !prevButton || !nextButton) return

  const modalImage = dialog.querySelector('img')
  const modalTitle = dialog.querySelector('h2')
  const modalContent = dialog.querySelector('.popup-text')

  const popups = Array.from(document.querySelectorAll('.popup-content'))
  const buttons = Array.from(document.querySelectorAll('.usp-list > li > button'))

  let currentIndex = 0
  let scrollPosition = 0

  function updateModal(index) {
    const popup = popups[index]
    if (!popup) return

    const imgElement = popup.querySelector('img')
    const titleElement = popup.querySelector('h2')
    const textElement = popup.querySelector('.popup-text')

    if (modalImage) {
      modalImage.src = imgElement ? imgElement.src : ''
      modalImage.alt = imgElement ? imgElement.alt : 'No image available'
    }
    if (modalTitle) modalTitle.innerHTML = titleElement ? titleElement.innerHTML : 'No title'
    if (modalContent)
      modalContent.innerHTML = textElement ? textElement.innerHTML : 'No content available'

    const paragraphs = textElement ? textElement.querySelectorAll('p') : []

    if (paragraphs.length >= 3) {
      paragraphs[paragraphs.length - 1].classList.add('more-than-three')
    } else {
      paragraphs.forEach(p => p.classList.remove('more-than-three'))
    }

    currentIndex = index

    prevButton.disabled = currentIndex === 0
    nextButton.disabled = currentIndex === popups.length - 1
  }

  function openModal(index) {
    if (!dialog) return
    updateModal(index)

    scrollPosition = window.scrollY

    document.body.style.top = `-${scrollPosition}px`
    document.body.style.position = 'fixed'

    dialog.showModal()
  }

  function closeModal() {
    dialog.close()

    document.body.style.position = ''
    document.body.style.top = ''
    window.scrollTo(0, scrollPosition)
  }

  buttons.forEach((button, index) => {
    button.addEventListener('click', () => openModal(index))
  })

  nextButton.addEventListener('click', () => {
    if (currentIndex < popups.length - 1) updateModal(currentIndex + 1)
  })
  prevButton.addEventListener('click', () => {
    if (currentIndex > 0) updateModal(currentIndex - 1)
  })

  closeButton.addEventListener('click', closeModal)

  dialog.addEventListener('click', event => {
    if (event.target === dialog) closeModal()
  })
})
